import axios from "axios";

/**
* API setup
* ---------
* This file configures a reusable Axios API instance for making requests.
* The API instance is used in authentication files and services.
* The base URL is determined by the browser URL (dev vs. production).
**/

const getBaseUrl = (): string => {
  const currentUrl = window.location.href;
  const baseUrl =
    currentUrl.includes("dev") || currentUrl.includes("localhost")
      ? "https://integration.valyrion.com" // development (change this, to test with dev environment)
      : "https://integration.valyrion.com"; // production (do NOT change)
  console.log("Current API Base URL:", baseUrl);
  return baseUrl;
};

const API = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

export const newAPI = axios.create({
  baseURL: "https://prod-valyrionservice-app.greenbeach-3240f091.swedencentral.azurecontainerapps.io/api",
  headers: {
    "Content-Type": "application/json",
  }
})


export default API;